import { useEffect, useRef, useState } from 'react';

export function useOutsideAlerter(
	ref: any,
	setModalOpen: (isOpen: boolean) => void,
	setWarnModalOpen: (isOpen: boolean) => void,
	isChanged: boolean
) {
	useEffect(() => {
		function handleClickOutside(event: any) {
			if (ref.current && !ref.current.contains(event.target)) {
				if (isChanged) setWarnModalOpen(true);
				else setModalOpen(false);
			}
		}
		// Bind the event listener
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [ref, isChanged]);
}

export default function useDetectClickOut(initState: any) {
	const triggerRef: any = useRef(null); // optional
	const nodeRef: any = useRef(null); // required

	const [show, setShow] = useState(initState);
	const handleClickOutside = (event: any) => {
		//if click is on trigger element, toggle modal
		if (triggerRef.current && triggerRef.current.contains(event.target)) {
			return setShow(!show);
		}

		//if modal is open and click is outside modal, close it
		if (nodeRef.current && !nodeRef.current.contains(event.target)) {
			return setShow(false);
		}
	};
	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	});
	return {
		triggerRef,
		nodeRef,
		show,
		setShow
	};
}
